import styled from 'styled-components'

export interface MarginProps {
  display?: string

  top?: string
  right?: string
  bottom?: string
  left?: string

  horizontal?: string
  vertical?: string

  all?: string
}
export const Margin = styled.div<MarginProps>`
  display: ${props => props.display ?? 'block'};

  ${props =>
    props.all &&
    `
    margin-top: ${props.all};
    margin-bottom: ${props.all};
    margin-right: ${props.all};
    margin-left: ${props.all};
  `}

  ${props =>
    props.vertical &&
    `
    margin-top: ${props.vertical};
    margin-bottom: ${props.vertical};
  `}
  ${props =>
    props.horizontal &&
    `
    margin-right: ${props.horizontal};
    margin-left: ${props.horizontal};
  `}

  ${props => props.top && `margin-top: ${props.top};`}
  ${props => props.right && `margin-right: ${props.right};`}
  ${props => props.bottom && `margin-bottom: ${props.bottom};`}
  ${props => props.left && `margin-left: ${props.left};`}
`
